import { observer } from 'mobx-react';
import { FC } from 'react';
import { orderConfigurationStore } from '../../store/orderConfigurationStore';
import { TBooleanInNumber } from 'src/types/main';
import Text, { TEXT } from 'src/view/components/Text/Text';
import integrationsStore from '~/mobx/integrationStore';
import { TaxConfiguration } from '~/view/screens/SettingsScreen/screens/Orders/containers/TaxConfiguration/TaxConfiguration';
import './style.scss';

export const TaxConditionsSettings: FC = observer((): JSX.Element => {
  const handleVatIncludedChange = (status: TBooleanInNumber) => {
    orderConfigurationStore.changeOrderConditions({ vatIncluded: status });
  };

  const handleTaxableDeliveryFeeChange = (status: TBooleanInNumber) => {
    orderConfigurationStore.changeOrderConditions({ taxableDeliveryFee: status });
  };

  const handleVatPercentageChange = (value: string | undefined) => {
    orderConfigurationStore.changeOrderConditions({ vat: value });
  };

  return (
    <div className="tax-condition-settings">
      <Text text="conditions" type={TEXT.SECTION_HEADER} />
      <TaxConfiguration
        vatIncluded={orderConfigurationStore.orderSettings.config.vatIncluded}
        taxableDeliveryFee={orderConfigurationStore.orderSettings.config.taxableDeliveryFee}
        vatAmount={orderConfigurationStore.orderSettings.config.vat}
        vatIncludedAccess={integrationsStore.posRestrictions?.vatIncludedToggle}
        vatAccess={integrationsStore.posRestrictions?.amountPercent}
        vatAmountError={orderConfigurationStore.errorMessages.vat}
        onChangeVatIncluded={handleVatIncludedChange}
        onChangeTaxableDeliveryFee={handleTaxableDeliveryFeeChange}
        onChangeVatAmount={handleVatPercentageChange}
      />
    </div>
  );
});
